import {
  Component,
  Inject,
  ViewEncapsulation,
  DOCUMENT,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Platform } from '@ionic/angular';
import { delay } from 'rxjs/operators';
import {
  AchievementSystemService,
  UserStorageService,
  AppHintService,
  ConfigService,
  GTagService,
} from '@shared/services';
import { AnnounceService, BreakPointsService, FocusService } from '@shared/services';
import { AchievementModel, AchievementProgressModel } from '@shared/models';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MainComponent {
  isShowFooter: boolean = true;
  isNavOpen: boolean = false;
  appSettings: any;
  readonly hasNavSideButtons = inject(BreakPointsService).hasNavSideButtons;
  showAchievement: {
    achievement: AchievementModel;
    reward: any;
    progress: AchievementProgressModel;
  };

  constructor(
    public userStorage: UserStorageService,
    public hintService: AppHintService,
    private gTag: GTagService,
    private platform: Platform,
    private appConfig: ConfigService,
    private announcer: AnnounceService,
    private focusService: FocusService,
    private achievementSystem: AchievementSystemService,
    @Inject(DOCUMENT) private document: any,
  ) {
    this.appSettings = this.appConfig.defaultSettings;
    this.appConfig.onSettingsChanged
      .pipe(takeUntilDestroyed(), delay(0))
      .subscribe((newSettings) => {
        this.appSettings = newSettings;
      });

    this.achievementSystem.showNotification$.subscribe((obj: any) => {
      this.showAchievement = obj;
    });
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.document.body.className += ' is-mobile';
      this.isShowFooter = false;
    }

    if (!this.platform.is('cordova')) {
      window.addEventListener('beforeunload', () => {
        this.sendData();
      });
    }
  }

  sendData() {
    const w: any = window;
    if (this.gTag.isGTagAvailable && w.performance) {
      let companyName: string = 'no_company';
      const hostname = w.location.hostname;
      if (this.userStorage.User) {
        companyName = this.userStorage.User.companyName || companyName;
      } else if (hostname.includes('programs')) {
        return;
      }
      this.gTag.sendTime(hostname, Math.round(performance.now()), companyName);
    }
  }

  onNavClosed() {
    this.announcer.announce('Navigation closed', 'assertive');
  }

  onNavOpened() {
    this.announcer.announce('Navigation opened', 'assertive');
  }

  skipToMainContent(event: Event) {
    event.preventDefault();
    this.focusService.focusPage({ preventScroll: true });
  }
}
